import Icon from '../components/Icon.vue'

Icon.register({
  'file-audio': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM160 404C160 414.7 147.1 420 139.5 412.5L104 376H76C69.4 376 64 370.6 64 364V308C64 301.4 69.4 296 76 296H104L139.5 259.5C147.1 251.9 160 257.3 160 268V404zM193.2 356.4C202.3 347.1 202.3 332.3 193.2 323 171.1 300.2 205.4 266.8 227.6 289.5 254.8 317.4 254.8 361.9 227.6 389.9 205.8 412.2 170.7 379.5 193.2 356.4zM279.2 239.3C333.6 295.2 333.6 384.1 279.2 440.1 257.4 462.5 222.2 429.8 244.8 406.6 281 369.4 281.1 310.1 244.8 272.8 222.7 250 257.1 216.5 279.2 239.3zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-audio.js
// module id = UVNW
// module chunks = 144